import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENTS = {
  OPEN: "Opened",
  CLOSE: "Closed",
  DELETED: "Deleted",
  NAVIGATED_TO: COMMON_EVENT_NAMES.NAVIGATED
};

export const LABELS = {
  BETSLIP: "Betslip",
  RACE_CARD: "Race Card Active Bets",
  BET: "Bet",
  MY_BETS_TAB: "My Bets Tab"
};
